import { Outlet } from 'react-router-dom'
import FooterSiteOfficiel from '@/components/site-officiel/footer-site-officiel'
import { GtLanguages } from '@/components/common/gt-languages/gt-languages'

export default function EspaceProContentLayout() {
  return (
    <main>
      <div className="flex justify-end p-4">
        <GtLanguages />
      </div>
      <Outlet />
      <FooterSiteOfficiel />
    </main>
  )
}
